export default __webpack_public_path__ + "static/media/shake3.54d42a57.jpg";